'use client';

import classNames from 'classnames';
import { IMaskInput } from 'react-imask';
import { useField, ErrorMessage } from 'formik';
import { IFormFieldTextProps } from 'app/interfaces/forms';
import FormFieldError from 'app/components/common/FormFieldError';
import { useRef, useState } from 'react';

export default function FormFieldText({
  name,
  type = 'text',
  placeholder,
  formatValue,
  prepareValue,
  mask,
  maskBlocks,
  className
}: IFormFieldTextProps) {
  const [field, meta, helpers] = useField({ name });
  const [isFocused, setIsFocused] = useState(false);
  const maskComponentRef = useRef(null);

  const handleChange = (value?: string) => {
    let currentValue = value?.trimStart() || '';
    if (typeof formatValue === 'function' && !mask) {
      currentValue = formatValue(currentValue);
    }
    helpers.setValue(currentValue);
  };

  return (
    <div className="flex flex-col gap-1">
      <div>
        {mask ? (
          <IMaskInput
            name={name}
            type={type}
            placeholder={placeholder}
            mask={mask}
            blocks={maskBlocks}
            lazy={!isFocused}
            onAccept={value => {
              handleChange(value);
            }}
            prepare={prepareValue}
            ref={maskComponentRef}
            onFocus={() => {
              setIsFocused(true);
            }}
            onBlur={() => {
              setIsFocused(false);
              helpers.setTouched(true, false);
            }}
            className={classNames('input-text', className, {
              'has-value': !!field.value,
              'has-error': meta.error && meta.touched
            })}
          />
        ) : (
          <input
            {...field}
            type={type}
            placeholder={placeholder}
            onChange={e => handleChange(e.target.value)}
            className={classNames('input-text', className, {
              'has-value': !!field.value,
              'has-error': meta.error && meta.touched
            })}
          />
        )}
      </div>

      <ErrorMessage
        component={() => <FormFieldError message={meta.error} />}
        name={name}
      />
    </div>
  );
}
